import React, { Component } from "react";
import "../../css/route.css";
import {toInt, format_date_only} from '../../Utils';
import {Table, Glyphicon, Well } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Collapsible from '../../components/Collapsible';
import TransactionDetails from  "../../TransactionDetails";
import { ReportService } from "../../Services/ReportService";

export default class Summary extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        routeRows: [],
        summaryRows: [],
        datePickerDate: moment(),
        maxDatePickerDate: moment(),
        message : "",
        transactionModal: null
      }
      this.handleDateChange = this.handleDateChange.bind(this);
      this.viewTransactions = this.viewTransactions.bind(this);
    }

    viewTransactions(e, report){
        report.product_id = report.product;
        console.log(report);
        this.setState({transactionModal: null}, ()=> {
            let transactionModal = <TransactionDetails report={report} agent_id={null} startDate={this.state.datePickerDate} endDate={moment(this.state.datePickerDate).add(1, "days")} />;
            this.setState({transactionModal: transactionModal});
        });
    }
    
 
    componentDidMount(){
        this.props.isLoading(true);
        this.props.setTitle('Summary Report');
        ReportService.getReportMax()
        .then((data) => {
            console.log(data.date);
            let d = moment(data.date !== null ? data.date: new Date());
            this.setState({
                //datePickerDate: d,
                maxDatePickerDate: d
            });
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error)
            this.props.isLoading(false);
        });
        this.fetchData(this.state.datePickerDate);
    }

    fetchData(date){
        this.props.isLoading(true);
        let routeRows = [], summaryRows = [];
        let routeMap = new Map(), productMap = new Map();
        ReportService.getReportSummary(date)
        .then((data) => {
            console.log(data.report);
            this.setState({
                data: data.report
            });
            data.report.forEach((report) => {
                let a = [], p = {};
                if(routeMap.has(report.route_id)){
                    a = routeMap.get(report.route_id);
                }
                if(productMap.has(report.product)){
                    p = productMap.get(report.product);
                    p.actual_count += toInt(report.actual_count);
                    p.delivered_count += toInt(report.delivered_count);
                    p.bottles_returned += toInt(report.bottles_returned);
                } else {
                    p = {
                        product: report.product,
                        actual_count: toInt(report.actual_count),
                        delivered_count: toInt(report.delivered_count),
                        bottles_returned: toInt(report.bottles_returned),
                        bottled: report.bottled
                    }
                }
                a.push(<ReportDetails key={report.id} report={report} viewTransactions={this.viewTransactions}/>);
                routeMap.set(report.route_id, a);
                productMap.set(report.product, p);
            });
            routeMap.forEach((value, key, map) => {
                routeRows.push(
                    <RouteDetails key={key} title={key} rows={value}/>
                );
            });
            productMap.forEach((value, key, map) => {
                summaryRows.push(
                    <SummaryDetails key={key} title={key} report={value}/>
                );
            });
            this.setState({routeRows: routeRows, summaryRows: summaryRows, message: routeMap.size > 0 ? "" : "No Data available"});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleDateChange(date){
        this.setState({
            datePickerDate: date
        });
        this.fetchData(date);
    }
    
    render() {
        const message = this.state.message;
        return (
            <div className="Home" style={{marginTop: 32}}>
                <div >
                    <DatePicker 
                        className="datePicker"
                        selected={this.state.datePickerDate} 
                        onChange={this.handleDateChange}  
                        todayButton={"TODAY"}
                        dateFormat={format_date_only}
                        maxDate={this.state.maxDatePickerDate}
                        withPortal
                        tabIndex={1}
                        title="Select Date"/>
                </div>
                <br/>
                {   !this.props.loading &&
                        this.state.data.length > 0 &&
                            <Well>
                                <Table striped condensed hover responsive style={{maxWidth: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Actual Count</th>
                                            <th>Delivered Count</th>
                                            <th>Bottles Returned Count</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{textAlign: "left"}}>
                                        {this.state.summaryRows}
                                    </tbody>
                                </Table>
                            </Well>
                }
                { !this.props.loading &&
                    <div className="container">
                        {this.state.routeRows}
                    </div>
                }
                {
                    message && 
                    (
                        <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    )
                }
                {this.state.transactionModal}
            </div>
        );
    }

}

class RouteDetails extends Component {

    render() {
        return (
            <Collapsible title={this.props.title}>
                <Table striped condensed hover responsive>
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Actual Count</th>
                            <th>Delivered Count</th>
                            <th>Bottles Returned Count</th>
                            <th>Transactions</th>
                        </tr>
                    </thead>
                    <tbody style={{textAlign: "left"}}>
                        {this.props.rows}
                    </tbody>
                </Table>
            </Collapsible>
        );
    }
}

class ReportDetails extends Component {

    render(){
        const report = this.props.report;
        const isBottled = report.bottled === "1" ? true : false;
        return (
            <tr>
                <td>{report.product}</td>
                <td>{report.actual_count}</td>
                <td>{report.delivered_count}</td>
                <td>{isBottled ? report.bottles_returned : "NA"}</td>
                <td>
                    { report.actual_count !== report.delivered_count &&
                        <Glyphicon style={{marginRight: "10px"}} glyph="book" onClick={(e) => this.props.viewTransactions(e, report)} />
                    }
                </td>
            </tr>
        );
    }
}

class SummaryDetails extends Component {

    render(){
        const report = this.props.report;
        const isBottled = report.bottled === "1" ? true : false;
        return (
            <tr>
                <td>{report.product}</td>
                <td>{report.actual_count}</td>
                <td>{report.delivered_count}</td>
                <td>{isBottled ? report.bottles_returned : "NA"}</td>
            </tr>
        );
    }
}